import styled from '@emotion/styled';
import { ShopTypes } from '~/lib/data-contract';
import { useTranslations } from '~/services/umbraco/hooks';
import { Text } from '~/shared/components/Text';

type Props = {
    status: ShopTypes.OrderStatus;
    noIndicator?: boolean;
    statusCode?: string;
};

export default function DeliveryStatus({ status, noIndicator, statusCode }: Props) {
    const { translate } = useTranslations();

    const getStatusTranslation = () => {
        switch (status) {
            case ShopTypes.OrderStatus.Delivered:
                return translate('mit-fog.orders.delivered');
            case ShopTypes.OrderStatus.Invoiced:
                return translate('mit-fog.orders.invoiced');
            case ShopTypes.OrderStatus.Delivering:
                return translate('mit-fog.orders.delivering');
            case ShopTypes.OrderStatus.Processing:
                return translate('mit-fog.orders.processing');
            case ShopTypes.OrderStatus.Reserved:
                return translate('mit-fog.orders.reserved');
            case ShopTypes.OrderStatus.UseStatusCode:
                return statusCode;
        }
    };

    return (
        <Wrapper>
            {noIndicator ? null : <DeliveryIndicator status={status} />}
            <StyledText>{getStatusTranslation()}</StyledText>
        </Wrapper>
    );
}

export const DeliveryIndicator = styled.span<{ status: ShopTypes.OrderStatus }>(
    ({ theme, status }) => {
        let backgroundColor;

        switch (status) {
            case ShopTypes.OrderStatus.Delivered:
                backgroundColor = theme.colors.success;
                break;
            case ShopTypes.OrderStatus.Invoiced:
                backgroundColor = theme.colors.success;
                break;
            case ShopTypes.OrderStatus.Delivering:
                backgroundColor = theme.colors.orange;
                break;
            case ShopTypes.OrderStatus.Processing:
                backgroundColor = theme.colors.orange;
                break;
            default:
                backgroundColor = '';
        }

        return {
            display: 'inline-block',
            height: 6,
            width: 6,
            borderRadius: '50%',
            marginRight: theme.space[2],
            backgroundColor,
        };
    },
);
export const StyledText = styled(Text)({
    whiteSpace: 'nowrap',
});
export const Wrapper = styled.div({
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
    alignItems: 'center',
});
